import * as styles from "./MenuArrow.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

import { useMenuContext } from "./Menu.context";

export function MenuArrow({
  className,
  ...props
}: React.ComponentProps<typeof BaseMenu.Arrow>): JSX.Element {
  const { size } = useMenuContext();

  return (
    <BaseMenu.Arrow
      data-slot="menu-arrow"
      className={clsx(styles.arrow({ size }), className)}
      {...props}
    />
  );
}
